<template></template>

<script>
export default {
  name: 'RedirectToMobilePost',
  props: ['id'],
  mounted() {
    const os = this.detectOS();
    const redirect = os === 'iOS' || os === 'MacOS'
      ? 'https://apps.apple.com/sg/app/etonhouse-parents/id6443718169'
      : 'https://play.google.com/store/apps/details?id=sg.etonhouse.mobile.parent&hl=en-SG';
    window.location.replace("/app");
    // window.location.replace(redirect);
  },
  methods: {
    detectOS() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
      } else if (/Macintosh|MacIntel|MacPPC|Mac68K/.test(userAgent)) {
        return "MacOS";
      } else {
        return "Other";
      }
    }
  }
}
</script>